const data = {
    "Camera Setup": {
        "name": "Camera Setup",
        "id": "cameraSetup",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "Iris Mode": {
                        "name": "Iris Mode",
                        "default": "Manual",
                        "settings": ["Automatic", "Manual"]  
                    },
                    "Iris Increment": {
                        "name": "Iris Increment",
                        "default": "1/3 stop",
                        "settings": ["1/2 stop", "1/3 stop"] 
                    },
                    "Fine Increment": {
                        "name": "Fine Increment",
                        "default": "Off",
                        "settings": ["On", "Off"]  
                    },
                    "Zoom Iris Correct": {
                        "name": "Zoom Iris Correct.",
                        "default": "Off",
                        "settings": ["On", "Off"]  
                    },
                    "Extended ND Range": {
                        "name": "Extended ND Range",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    }
                }
            },
            "2": {
                "name": "2",
                "settings": {
                    "Shutter Mode": {
                        "name": "Shutter Mode",
                        "default": "Speed",
                        "settings": ["Speed", "Angle", "Clear Scan", "Slow", "Off"]
                    },
                    "Shutter Increment": {
                        "name": "Shutter Increment",
                        "default": "1/4 stop",
                        "settings": ["1/3 stop", "1/4 stop"]
                    },
                    "ISO/Gain": {
                        "name": "ISO/Gain",
                        "default": "ISO",
                        "settings": ["ISO", "Gain"]
                    },
                    "ISO/Gain Extended Range": {
                        "name": "ISO/Gain Extended Range",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "ISO Increment": {
                        "name": "ISO Increment",
                        "default": "1/3 stop",
                        "settings": ["1 stop", "1/3 stop"]
                    },
                    "Gain Increment": {
                        "name": "Gain Increment",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    }
                }
            },
            "3": {
                "name": "3",
                "settings": {
                    "Light Metering": {
                        "name": "Light Metering",
                        "default": "Standard",
                        "settings": ["Backlight", "Standard", "Spotlight"]
                    },
                    "AE Shift": {
                        "name": "AE Shift",
                        "default": "+-0",
                        "settings": ["+2.0", "+1.75", "+1.5", "+1.25", "+1.0", "+0.75", "+0.5", "+0.25", "+-0", "-0.25", "-0.5", "-0.75", "-1.0", "-1.25", "-1.5", "-1.75", "-2.0"]
                    },
                    "AE Response": {
                        "name": "AE Response",
                        "default": "Normal",
                        "settings": ["High", "Normal", "Low"]
                    },
                    "Shockless WB": {
                        "name": "Shockless WB",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "AWB Response": {
                        "name": "AWB Response",
                        "default": "Normal",
                        "settings": ["High", "Normal", "Low"]
                    }
                }
            },
            "4": {
                "name": "4",
                "settings": {
                    "AF Mode": {
                        "name": "AF Mode",
                        "default": "One Shot",
                        "settings": ["One Shot", "AF-Boosted MF", "Continuous"]
                    },
                    "AF Frame Position": {
                        "name": "AF Frame Position",
                        "default": "Selectable",
                        "settings": ["Selectable", "Center Frame"]
                    },
                    "AF Frame Size": {
                        "name": "AF Frame Size",
                        "default": "Large",
                        "settings": ["Large", "Small"]
                    },
                    "Apply AF Speed Limit": {
                        "name": "Apply AF Speed Limit",
                        "default": "Always",
                        "settings": ["Always", "Only While Recording"]
                    },
                    "AF Speed": {
                        "name": "AF Speed",
                        "default": "0",
                        "settings": ["+2", "+1", "0", "-1", "-2", "-3", "-4", "-5", "-6", "-7"]
                    },
                    "AF Response": {
                        "name": "AF Response",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    }
                }
            },
            "5": {
                "name": "5",
                "settings": {
                    "Face detection": {
                        "name": "Face detection",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "Face AF": {
                        "name": "Face AF",
                        "default": "Face Priority",
                        "settings": ["Face Priority", "Face Only"]
                    },
                    "Camera Grip Zoom": {
                        "name": "Camera Grip Zoom",
                        "disabled": true,
                        "default": "---"
                    },
                    "Camera Grip Zoom Speed": {
                        "name": "Camera Grip Zoom Speed",
                        "disabled": true,
                        "default": "---"
                    },
                    "Tele-converter": {
                        "name": "Tele-converter",
                        "disabled": true,
                        "default": "---"
                    },
                    "EF-S Lens": {
                        "name": "EF-S Lens",
                        "disabled": true,
                        "default": "---"
                    }
                }
            },
            "6": {
                "name": "6",
                "settings": {
                    "ABB": {
                        "name": "ABB",
                        "default": false,
                        "type": "question",
                        "title": "Attach the Body Cap",
                        "question": "OK?",
                    },
                    "Color Bars": {
                        "name": "Color Bars",
                        "disabled": true,
                        "default": "---"
                    },
                    "Color Bar Type": {
                        "name": "Color Bar Type",
                        "disabled": true,
                        "default": "---"
                    },
                    "Periph. Illum. Corr.": {
                        "name": "Periph. Illum. Corr.",
                        "default": "Off",
                        "type": "vertical_select",
                        "settings": ["Off", "On"]
                    },
                    "Chromatic Aberr. Corr.": {
                        "name": "Chromatic Aberr. Corr.",
                        "default": "Off",
                        "type": "vertical_select",
                        "settings": ["Off", "On"]
                    }
                }
            }
        }
    },
    "Custom Picture/HDR": {
        "name": "Custom Picture/HDR",
        "id": "customPicture",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "HDR/LUT": {
                        "name": "HDR/LUT",
                        "default": "HDR: Off",
                        "type": "selection_tree",
                        "settings": {
                            "title": "Canon Log 3",
                            "options": [["HDR: Off", "HDR: NLG", "HDR: PQ" ], ["LUT: Off", "LUT: BT.709"], ["LUT: Off", "LUT: BT.709", "LUT: HDR Assist. (1600%)", "LUT: HDR Assist. (400%)"], ["LUT: Off", "LUT: BT.709", "LUT: HDR Assist. (1600%)", "LUT: HDR Assist. (400%)"], ["LUT: Off"]],
                            "settings": ["HDMI", "SDI", "VIDEO", "VF", "SD CARD"]
                        }
                    },
                    "Preset": {
                        "name": "Preset",
                        "default": "Off",
                        "settings": ["Canon Log 3", "Canon Log", "BT.709", "Off"]
                    },
                    "Gamma": {
                        "name": "Gamma",
                        "default": "Canon Log 3",
                        "settings": ["Canon Log 3", "Canon Log", "Wide DR", "Normal 1 (Standard)", "Normal 2(x4.0)", "Normal 3(BT.709)", "Normal 4(x5.0)"]
                    },
                    "Color Matrix": {
                        "name": "Color Matrix",
                        "default": "Neutral",
                        "settings": ["Neutral", "Production Camera", "Cinema EOS Original", "Video", "Off"]
                    },
                    "Activate Other Settings": {
                        "name": "Acitvate Other Settings",
                        "default": "Off",
                        "type": "vertical_select",
                        "title": "C1:CP000001",
                        "settings": ["Off", "On"]
                    },
                    "Other settings": {
                        "name": "Other settings",
                        "default": false,
                        "type": "list",
                        "parentName": "Custom Picture/HDR",
                        "settings": {
                            "Black": {
                                "name": "Black",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "Master Pedestral": {
                                        "name": "Master Pedestral",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Master Black Red": {
                                        "name": "Master Black Red",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Master Black Green": {
                                        "name": "Master Black Green",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Master Black Blue": {
                                        "name": "Master Black Blue",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            },
                            "Black Gamma": {
                                "name": "Black Gamma",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "Level": {
                                        "name": "Level",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Range": {
                                        "name": "Range",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Point": {
                                        "name": "Point",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            },
                            "Low Key Satur.": {
                                "name": "Low Key Satur.",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "Activate": {
                                        "name": "Activate",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Level": {
                                        "name": "Level",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            },
                            "Knee": {
                                "name": "Knee",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "Activate": {
                                        "name": "Activate",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Slope": {
                                        "name": "Slope",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Point": {
                                        "name": "Point",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Sturation": {
                                        "name": "Sturation",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            },
                            "Sharpness": {
                                "name": "Sharpness",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "Level": {
                                        "name": "Level",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "H Detail Freq.": {
                                        "name": "H Detail Freq.",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Coring Level": {
                                        "name": "Coring Level",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Coring D-Ofst": {
                                        "name": "Coring D-Ofst",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Coring D-Curve": {
                                        "name": "Coring D-Curve",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "HV Detail Bal.": {
                                        "name": "HV Detail Bal.",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Limit": {
                                        "name": "Limit",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Select": {
                                        "name": "Select",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Knee Aperture Gain": {
                                        "name": "Knee Aperture Gain",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Knee Aperture Slope": {
                                        "name": "Knee Aperture Slope",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Level Depend Level": {
                                        "name": "Level Depend Level",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Level Depend Slope": {
                                        "name": "Level Depend Slope",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Level Depend Offset": {
                                        "name": "Level Depend Offset",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                    
                                }
                            },
                            "Noise Reduction": {
                                "name": "Noise Reduction",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "Level": {
                                        "name": "Level",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            },
                            "White Balance": {
                                "name": "White Balance",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "R Gain": {
                                        "name": "R Gain",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "B Gain": {
                                        "name": "B Gain",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            },
                            "Color Matrix Tuning": {
                                "name": "Color Matrix Tuning",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                    "Gain": {
                                        "name": "Gain",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Phase": {
                                        "name": "Phase",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "R-G": {
                                        "name": "R-G",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "R-B": {
                                        "name": "R-B",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "G-R": {
                                        "name": "G-R",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "G-B": {
                                        "name": "G-B",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "B-R": {
                                        "name": "B-R",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "B-G": {
                                        "name": "B-G",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            },
                            "Other Functions": {
                                "name": "Other Functions",
                                "default": false,
                                "type": "list",
                                "parentName": "Custom Picture/HDR",
                                "settings": {
                                  "Setup Level": {
                                        "name": "Setup Level",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    },
                                    "Over 100%": {
                                        "name": "Over 100%",
                                        "disabled": true,
                                        "default": "---",
                                        "settings": ["---"]
                                    }
                                }
                            }
                        }
                    },
                    "File": { 
                        "name": "File",
                        "default": false,
                        "type": "list",
                        "parentName": "Custom Picture/HDR",
                        "settings": {
                            "Select": {
                                "name": "Select",
                                "default": "C1:CP000001",
                                // "showParentName": true,
                                "parentName": "File",
                                "title": "C1:CP000001",
                                "type": "vertical_select",
                                "settings": ["C1:CP000001", "C2:CP000002", "C3:CP000003", "C4:CP000004", "C5:CP000005"]
                            },
                            "Rename": {
                                "name": "Rename",
                                "default": false,
                                "type": "input",
                                "title": "File Name",
                                "parentName": "File",
                                "question": "CP000001", /// ???
                                "settings": {
                                    "Custom Picture/Rename": {
                                        "name": "Custom Picture/Rename",
                                        "default": "CP000001", 
                                        "title": "CP000001",
                                        "type": "keyboard"
                                        }
                                    }
                            },
                            "Protect": {
                                "name": "Protect",
                                "default": "Unprotect",
                                // "showParentName": true,
                                "parentName": "File",
                                "title": "C1:CP000001",
                                "type": "vertical_select",
                                "settings": ["Unprotect", "Protect"]
                            },
                            "Reset": {
                                "name": "Reset",
                                "default": false,
                                "type": "question",
                                "title": "C1:CP000001",
                                "question": "Reset?",
                                "settings": [], // ??
                            },
                            "Copy to SD Card B": {
                                "name": "Copy to SD Card B",
                                "default": false,
                                // "showParentName": true,
                                "parentName": "File",
                                "title": "C1:CP000001",
                                "type": "vertical_select",
                                "settings": ["New File", "SD1:CP000001"]
                            },
                            "Load from SD Card B": {
                                "name": "Load from SD Card B",
                                "default": false,
                                // "showParentName": true,
                                "parentName": "File",
                                "title": "C1:CP000001",
                                "type": "vertical_select",
                                "settings": ["SD1:CP000001"]
                            }
                        }
                    }
                }
            }
        }
    },
    "Recording/Media Setup": {
        "name": "Recording/Media Setup",
        "id": "recordingSetup",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "Initialize Media": {
                        "name": "Initialize Media",
                        "default": false,
                        "type": "list",
                        "parentName": "Recording/Media Setup",
                        "settings": {
                            "CFast": {
                                "name": "CFast",
                                "default": false,
                                "type": "question",
                                "parentName": "Initialize Media",
                                "title": "This will erase all the data. Do not remove the CFast card or the power source until the process ends.",
                                "question": "Initialize?",
                            },
                            "SD Card A": {
                                "name": "SD Card A",
                                "default": false,
                                "type": "question",
                                "parentName": "Initialize Media",
                                "title": "Will completely erase all data from the SD card. This operation may take a few moments.",
                                "question": "Initialize?",
                            },
                            "SD Card B": {
                                "name": "SD Card B",
                                "default": false,
                                "type": "question",
                                "parentName": "Initialize Media",
                                "title": "Will completely erase all data from the SD card. This operation may take a few moments.",
                                "question": "Initialize?",
                            }
                        }
                    },
                    "Main Rec Format" : {
                        "name": "Main Rec Format",
                        "default": "RAW (CFast)",
                        "settings": ["RAW (CFast)", "MP4 (SD Card)", "XF-AVC (SD Card)"]
                    },
                    "System Frequency": {
                        "name": "System Frequency",
                        "default": "59.94 Hz",
                        "settings": ["59.94 Hz", "50.00 Hz", "24.00 Hz"]
                    },
                    "Recording Mode": {
                        "name": "Recording Mode",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    },
                    "Recording Interval": {
                        "name": "Recording Interval",
                        "disabled": true,
                        "default": "1 sec",
                        "settings": ["1 sec"]
                    },
                    "Sub Rec Format": {
                        "name": "Sub Rec Format",
                        "default": "Off",
                        "settings": ["MP4 (SD Card)", "XF-AVC (SD Card)", "Off"]
                    },
                    "Continuous Recording": {
                        "name": "Continuous Recording",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    }
                }
            },
            "2": {
                "name": "2",
                "settings": {
                    "Frame Rate": {
                        "name": "Frame Rate",
                        "default": "59.94P",
                        "settings": ["59.94P", "29.97P", "23.98P"]
                    },
                    "Resolution/Color Sampling": {
                        "name": "Resolution/Color Sampling",
                        "disabled": true,
                        "default": "4096x2160 10bit",
                        "settings": ["4096x2160 10bit"]
                    },
                    "Audio Format (MP4)": {
                        "name": "Audio Format (MP4)",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    },
                    "Audio Format (RAW)": {
                        "name": "Audio Format (RAW)",
                        "default": "LPCM 16 bit 4CH",
                        "settings": ["LPCM 16 bit 4CH", "LPCM 24 bit 4CH"]
                    }
                }
            },
            "3": {
                "name": "3",
                "settings": {
                    "Relay Recording": {
                        "name": "Relay Recording",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    },
                    "Double Slot Recording": {
                        "name": "Double Slot Recording",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    }
                }
            },
            "4": {
                "name": "4",
                "settings": {
                    "Metadata": {
                        "name": "Metadata",
                        "default": false,
                        "type": "list",
                        "parentName": "Recording/Media Setup",
                        "settings": {
                            "Camera Index": {
                                "name": "Camera Index",
                                "default": "A",
                                "type": "select",
                                "settings": ["A"],
                                "parentName": "Metadata"
                            },
                            "Reel Number": {
                                "name": "Reel Number",
                                "default": "001",
                                "type": "change_reset",
                                "settings": ["001"],
                                "parentName": "Metadata"

                            },
                            "Clip Number": {
                                "name": "Clip Number",
                                "default": "001",
                                "type": "change_reset",
                                "settings": ["001"],
                                "parentName": "Metadata"
                            },
                            "User Defined": {
                                "name": "User Defined",
                                "default": "CANON",
                                "type": "change_reset",
                                "settings": ["CANON"],
                                "parentName": "Metadata"
                            },
                            "Scene": {
                                "name": "Scene",
                                "default": "(NONE)",
                                "type": "change_reset",
                                "settings": ["(NONE)"],
                                "parentName": "Metadata"

                            },
                            "Take": {
                                "name": "Take",
                                "default": "(NONE)",
                                "type": "change_reset",
                                "settings": ["(NONE)"],
                                "parentName": "Metadata"
                            },
                            "Setting": {
                                "name": "Setting",
                                "default": "SD Card",
                                "settings": ["Remote", "SD Card"]
                            },
                            "User Memo": {
                                "name": "User Memo",
                                "disabled": true,
                                "default": "---",
                                "settings": ["---"]
                            },
                            "Country Code": {
                                "name": "Country Code",
                                "default": false,
                                "type": "change_reset",
                                "settings": [],
                                "parentName": "Metadata"
                            },
                            "Organization": {
                                "name": "Organization",
                                "default": "00",
                                "type": "change_reset",
                                "settings": ["00"],
                                "parentName": "Metadata"
                            },
                            "User Code": {
                                "name": "User Code",
                                "default": false,
                                "type": "change_reset",
                                "settings": [],
                                "parentName": "Metadata"
                            },
                            "Add CP File": {
                                "name": "Add CP File",
                                "default": "Off",
                                "settings": ["On", "Off"]
                            },
                            "Clip Numbering": {
                                "name": "Clip Numbering",
                                "default": "Continuous",
                                "settings": ["Reset", "Continuous"]
                            }
                        }
                    },
                    "Rec Command": {
                        "name": "Rec Command",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "HDMI Time Code": {
                        "name": "HDMI Time Code",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "MP4 Clip/Photo Numbering": {
                        "name": "MP4 Clip/Photo Numbering",
                        "default": "Continuous",
                        "settings": ["Reset", "Continuous"]
                    }
                }
            }
        }
    },
    "Audio Setup": {
        "name": "Audio Setup",
        "id": "audioSetup",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "Select CH1/CH2 Input": {
                        "name": "Select CH1/CH2 Input",
                        "default": "INPUT Terminals",
                        "settings": ["INPUT Terminals", "MIC Terminal", "Monaural Mic"]
                    },
                    "CH2 Input": {
                        "name": "CH2 Input",
                        "default": "INPUT 2",
                        "settings": ["INPUT 2", "INPUT 1"]
                    },
                    "Select CH3/CH4 Input": {
                        "name": "Select CH3/CH4 Input",
                        "default": "INPUT Terminals",
                        "settings": ["INPUT Terminals", "MIC Terminal", "Monaural Mic"]
                    },
                    "CH1/CH2 ALC Link": {
                        "name": "CH1/CH2 ALC Link",
                        "default": "Separated",
                        "settings": ["Linked", "Separated"]
                    },
                    "CH3/CH4 ALC Link": {
                        "name": "CH3/CH4 ALC Link",
                        "default": "Separated",
                        "settings": ["Linked", "Separated"]
                    }
                }
            },
            "2": {
                "name": "2",
                "settings": {
                    "Audio Rec Level CH3": {
                        "name": "Audio Rec Level CH3",
                        "default": "Automatic",
                        "settings": ["Automatic", "Manual"]
                    },
                    "CH3 Level": {
                        "name": "CH3 Level",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    },
                    "Audio Rec Level CH4": {
                        "name": "Audio Rec Level CH4",
                        "default": "Automatic",
                        "settings": ["Automatic", "Manual"]
                    },
                    "CH4 Level": {
                        "name": "CH4 Level",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    },
                    "Audio Rec Level CH3/CH4": {
                        "name": "Audio Rec Level CH3/CH4",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    },
                    "CH3/CH4 Level": {
                        "name": "CH3/CH4 Level",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    }
                }
            },
            "3": {
                "name": "3",
                "settings": {
                    "INPUT 1 Mic Trimming": {
                        "name": "INPUT 1 Mic Trimming",
                        "default": "0 dB",
                        "settings": ["+12 dB", "+6 dB", "0 dB", "-6 dB", "-12 dB"]
                    },
                    "INPUT 1 Mic Att.": {
                        "name": "INPUT 1 Mic Att.",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "INPUT 2 Mic Trimming": {
                        "name": "INPUT 2 Mic Trimming",
                        "default": "0 dB",
                        "settings": ["+12 dB", "+6 dB", "0 dB", "-6 dB", "-12 dB"]
                    },
                    "INPUT 2 Mic Att.": {
                        "name": "INPUT 2 Mic Att.",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "INPUT 1&2 Limiter": {
                        "name": "INPUT 1&2 Limiter",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "MIC Att.": {
                        "name": "MIC Att.",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    },
                    "MIC Low Cut": {
                        "name": "MIC Low Cut",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]
                    }
                }
            },
            "4": {
                "name": "4",
                "settings": {
                    "1 kHz Tone": {
                        "name": "1 kHz Tone",
                        "default": "Off",
                        "settings": ["-12 dB", "-18 dB", "-20 dB", "Off"]
                    },
                    "Headphone Volume": {
                        "name": "Headphone Volume",
                        "default": "8",
                        "settings": ["Off", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"]
                    },
                    "Monitor Channels": {
                        "name": "Monitor Channels",
                        "default": "CH1/CH2",
                        "settings": ["CH1/CH2", "CH1/CH1", "CH2/CH2", "CH1+2/CH1+2", "CH3/CH4", "CH3/CH3", "CH4/CH4", "CH3+4/CH3+4", "CH1+3/CH2+4"]
                    },
                    "HDMI OUT Channels": {
                        "name": "HDMI OUT Channels",
                        "default": "CH1/CH2",
                        "settings": ["CH1/CH2", "CH3/CH4"]
                    }
                }
            }
        }
    },
    "Monitoring Setup": {
        "name": "Monitoring Setup",
        "id": "monitoringSetup",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "LCD LM-V1 Brightness": {
                        "name": "LCD LM-V1 Brightness",
                        "default": "+-0",
                        "type": "vertical_select",
                        "settings": ["+-0", "+1", "+2", "+3", "+4", "+5", "+6", "+7", "+8", "+9", "+10"]
                    },
                    "LCD LM-V1 Contrast": {
                        "name": "LCD LM-V1 Contrast",
                        "default": "+-0",
                        "type": "vertical_select",
                        "settings": ["+-0", "+1", "+2", "+3", "+4", "+5", "+6", "+7", "+8", "+9", "+10"]
                    },
                    "LCD LM-V1 Color": {
                        "name": "LCD LM-V1 Color",
                        "default": "+-0",
                        "type": "vertical_select",
                        "settings": ["+-0", "+1", "+2", "+3", "+4", "+5", "+6", "+7", "+8", "+9", "+10", "+11", "+12", "+13", "+14", "+15", "+16", "+17", "+18", "+19", "+20"]
                    },
                    "LCD LM-V1 Sharpness": {
                        "name": "LCD LM-V1 Sharpness",
                        "default": "1",
                        "type": "vertical_select",
                        "settings": ["1", "2", "3", "4"]
                    },
                    "LCD LM-V1 Luminance": {
                        "name": "LCD LM-V1 Luminance",
                        "default": "Normal",
                        "type": "vertical_select",
                        "settings": ["Normal", "+1", "+2"]
                    }
                }
            },
            "2": {
                "name": "2",
                "settings": {
                    "VF Brightness": {
                        "name": "VF Brightness",
                        "disabled": "true",
                        "default": "---"
                    },
                    "VF Contrast": {
                        "name": "VF Contrast",
                        "disabled": "true",
                        "default": "---"
                    },
                    "VF Color": {
                        "name": "VF Color",
                        "disabled": "true",
                        "default": "---"
                    },
                    "VF Sharpness": {
                        "name": "VF Sharpness",
                        "disabled": "true",
                        "default": "---"
                    },
                    "VF Luminance": {
                        "name": "VF Luminance",
                        "disabled": "true",
                        "default": "---"
                    },
                    "VF Eye Sensor": {
                        "name": "VF Eye Sensor",
                        "default": "On",
                        "type": "vertical_select",
                        "settings": ["On", "Off"]
                    }
                }
            },
            "3": {
                "name": "3",
                "settings": {
                    "EVF-V70 Brightness": {
                        "name": "EVF-V70 Brightness",
                        "disabled": "true",
                        "default": "---"
                    },
                    "EVF-V70 Contrast": {
                        "name": "EVF-V70 Contrast",
                        "disabled": "true",
                        "default": "---"
                    },
                    "EVF-V70 Color": {
                        "name": "EVF-V70 Color",
                        "disabled": "true",
                        "default": "---"
                    },
                    "EVF-V70 Sharpness": {
                        "name": "EVF-V70 Sharpness",
                        "disabled": "true",
                        "default": "---"
                    },
                    "EVF-V70 Luminance": {
                        "name": "EVF-V70 Luminance",
                        "disabled": "true",
                        "default": "---"
                    },
                    "EVF-V70 Eye Sensor": {
                        "name": "EVF-V70 Eye Sensor",
                        "disabled": "true",
                        "default": "---"
                    },
                }
            },
            "4": {
                "name": "4",
                "settings": {
                    "B&W Image: VIDEO Output": {
                        "name": "B&W Image: VIDEO Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "B&W Image: VF Output": {
                        "name": "B&W Image: VF Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    }
                }
            },
            "5": {
                "name": "5",
                "settings": {
                    "OSD Output": {
                        "name": "OSD Output",
                        "default": "On",
                        "settings": ["On", "Off"]
                    },
                    "Custom Display 1": {
                        "name": "Custom Display 1",
                        "default": false,
                        "type": "list",
                        "parentName": "Monitoring Setup",
                        "settings": {
                            "Light Metering": {
                                "name": "Light Metering",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Custom Picture/HDR": {
                                "name": "Custom Picture/HDR",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Focal Length": {
                                "name": "Focal Length",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "ND Filter": {
                                "name": "ND Filter",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Focus Mode": {
                                "name": "Focus Mode",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Key Lock": {
                                "name": "Key Lock",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "White Balance": {
                                "name": "White Balance",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "AE Shift": {
                                "name": "AE Shift",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Exposure Bar": {
                                "name": "Exposure Bar",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Iris": {
                                "name": "Iris",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "ISO/Gain": {
                                "name": "ISO/Gain",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Shutter": {
                                "name": "Shutter",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Peaking": {
                                "name": "Peaking",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Tele-converter": {
                                "name": "Tele-converter",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "EF-S Lens": {
                                "name": "EF-S Lens",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Magnification": {
                                "name": "Magnification",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "LUT": {
                                "name": "LUT",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Lens": {
                                "name": "Lens",
                                "default": "On",
                                "settings": ["On", "Off"]
                            }
                        }
                    },
                    "Custom Display 2": {
                        "name": "Custom Display 2",
                        "default": false,
                        "type": "list",
                        "parentName": "Monitoring Setup",
                        "settings": {
                            "Remaining Battery": {
                                "name": "Remaining Battery",
                                "default": "Normal",
                                "settings": ["Only Warnings", "Normal", "Off"]
                            },
                            "Remaining Rec Time": {
                                "name": "Remaining Rec Time",
                                "default": "Normal",
                                "settings": ["Only Warnings", "Normal", "Off"]
                            },
                            "Recording Mode": {
                                "name": "Recording Mode",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Time Code": {
                                "name": "Time Code",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Reel/Clip Number": {
                                "name": "Reel/Clip Number",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Interval Counter": {
                                "name": "Interval Counter",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Remaining Photos": {
                                "name": "Remaining Photos",
                                "default": "Normal",
                                "settings": ["Only Warnings", "Normal", "Off"]
                            },
                            "Temperature/Fan": {
                                "name": "Temperature/Fan",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Resolution/Color Sampling": {
                                "name": "Resolution/Color Sampling",
                                "disabled": true,
                                "default": "---"
                            },
                            "Frame Rate": {
                                "name": "Frame Rate",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Output Terminals Status": {
                                "name": "Output Terminals Status",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "OSD Output": {
                                "name": "OSD Output",
                                "default": "Off",
                                "settings": ["On", "Off"]
                            },
                            "Rec Command": {
                                "name": "Rec Command",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "User Memo": {
                                "name": "User Memo",
                                "default": "Off",
                                "settings": ["On", "Off"]
                            },
                            "User Bit": {
                                "name": "User Bit",
                                "default": "Off",
                                "settings": ["On", "Off"]
                            },
                            "Monitor Channels": {
                                "name": "Monitor Channels",
                                "default": "Off",
                                "settings": ["On", "Off"]
                            },
                            "Audio Level Indicator": {
                                "name": "Audio Level Indicator",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Network Functions": {
                                "name": "Network Functions",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "GPS": {
                                "name": "GPS",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Date/Time": {
                                "name": "Date/Time",
                                "default": "Off",
                                "settings": ["On", "Off"]
                            }
                        }
                    },
                    "Displayed Units": {
                        "name": "Displayed Units",
                        "default": "Feet",
                        "settings": ["Meters", "Feet"]
                    }
                }
            }
        }
    },
    "Assistance Functions": {
        "name": "Assistance Functions",
        "id": "assistanceFunctions",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "Focus Guide": {
                        "name": "Focus Guide",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "Focus Guide 2nd Frame": {
                        "name": "Focus Guide 2nd Frame",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    }
                }
            },
            "2": {
                "name": "2",
                "settings": {
                    "Peaking: VIDEO Output": {
                        "name": "Peaking: VIDEO Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "Peaking: VF Output": {
                        "name": "Peaking: VF Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "Peaking": {
                        "name": "Peaking",
                        "default": "Peaking 1",
                        "settings": ["Peaking 1", "Peaking 2"]
                    },
                    "Peaking 1": {
                        "name": "Peaking 1",
                        "default": false,
                        "type": "list",
                        "parentName": "Assistance Functions",
                        "settings": {
                            "Color": {
                                "name": "Color",
                                "default": "White",
                                "settings": ["White", "Red", "Yellow", "Blue"]
                            },
                            "Gain": {
                                "name": "Gain",
                                "default": "8",
                                "settings": ["Off", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"]
                            },
                            "Frequency": {
                                "name": "Frequency",
                                "default": "2",
                                "settings": ["1", "2", "3", "4"]
                            }
                        }
                    },
                    "Peaking 2": {
                        "name": "Peaking 2",
                        "default": false,
                        "type": "list",
                        "parentName": "Assistance Functions",
                        "settings": {
                            "Color": {
                                "name": "Color",
                                "default": "White",
                                "settings": ["White", "Red", "Yellow", "Blue"]
                            },
                            "Gain": {
                                "name": "Gain",
                                "default": "8",
                                "settings": ["Off", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15"]
                            },
                            "Frequency": {
                                "name": "Frequency",
                                "default": "2",
                                "settings": ["1", "2", "3", "4"]
                            }
                        }
                    },
                    "B&W during Peaking": {
                        "name": "B&W during Peaking",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    }
                }
            },
            "3": {
                "name": "3",
                "settings": {
                    "Magn.: VF+VIDEO Output": {
                        "name": "Magn.: VF+VIDEO Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "Magn.: SDI/HDMI Output" : {
                        "name": "Magn.: SDI/HDMI Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "B&W during Magn.": {
                        "name": "B&W during Magn.",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    }
                }
            },
            "4": {
                "name": "4",
                "settings": {
                    "Zebra: VIDEO Output": {
                        "name": "Zebra: VIDEO Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "Zebra: VF Output": {
                        "name": "Zebra: VF Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "Zebra": {
                        "name": "Zebra",
                        "default": "Zebra 1",
                        "settings": ["Zebra 1", "Zebra 2", "Zebra 1+2"]
                    },
                    "Zebra 1 Level": {
                        "name": "Zebra 1 Level",
                        "default": "70 +-5%",
                        "settings": ["5 +-5%", "10 +-5%", "15 +-5%", "20 +-5%", "25 +-5%", "30 +-5%", "35 +-5%", "40 +-5%", "45 +-5%", "50 +-5%", "55 +-5%", "60 +-5%", "65 +-5%", "70 +-5%", "75 +-5%", "80 +-5%", "85 +-5%", "90 +-5%", "95 +-5%"]
                    },
                    "Zebra 2 Level": {
                        "name": "Zebra 2 Level",
                        "default": "100%",
                        "settings": ["0%", "5%", "10%", "15%", "20%", "25%", "30%", "35%", "40%", "45%", "50%", "55%", "60%", "65%", "70%", "75%", "80%", "85%", "90%", "95%", "100%"]
                    }
                }
            },
            "5": {
                "name": "5",
                "settings": {
                    "WFM: VF+VIDEO Output": {
                        "name": "WFM: VF+VIDEO Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "WFM: SDI Output": {
                        "name": "WFM: SDI Output",
                        "default": "Off",
                        "settings": ["On", "Off"]
                    },
                    "WFM Type": {
                        "name": "WFM Type",
                        "default": "Line",
                        "settings": ["Line", "Line+Spot", "Select Line", "Field", "RGB", "YPbPr"]
                    },
                    "WFM Gain": {
                        "name": "WFM Gain",
                        "default": "1x",
                        "settings": ["1x", "2x"]
                    },
                    "WFM Y Position": {
                        "name": "WFM Y Position",
                        "disabled": true,
                        "default": "---"
                    },
                    "WFM Select Line": {
                        "name": "WFM Select Line",
                        "disabled": true,
                        "default": "---"
                    }
                }
            },
            "6": {
                "name": "6",
                "settings": {
                    "Markers: VF+VIDEO Output": {
                        "name": "Markers: VF+VIDEO Output",
                        "default": "On",
                        "settings": ["On", "Off"]
                    },
                    "Markers: SDI/HDMI Output": {
                        "name": "Markers: SDI/HDMI Output",
                        "default": "On",
                        "settings": ["On", "Off"]
                    },
                    "Center Marker": {
                        "name": "Center Marker",
                        "default": "Off",
                        "settings": ["Yellow", "Blue", "Green", "Red", "Black", "Gray", "White", "Off"]
                    },
                    "Horizontal Marker": {
                        "name": "Horizontal Marker",
                        "default": "Off",
                        "settings": ["Yellow", "Blue", "Green", "Red", "Black", "Gray", "White", "Off"]
                    },
                    "Grid Marker": {
                        "name": "Grid Marker",
                        "default": "Off",
                        "settings": ["Yellow", "Blue", "Green", "Red", "Black", "Gray", "White", "Off"]
                    },
                    "Aspect Marker": {
                        "name": "Aspect Marker",
                        "default": "Off",
                        "settings": ["Yellow", "Blue", "Green", "Red", "Black", "Gray", "White", "Off"]
                    },
                    "Marker Aspect Ratio": {
                        "name": "Marker Aspect Ratio",
                        "default": "2.39:1",
                        "settings": ["4:3", "13:9", "14:9", "16:9", "1.375:1", "1.66:1", "1.75:1", "1.85:1", "1.90:1", "2.35:1", "2.39:1", "Custom"]
                    },
                    "Marker Custom Asp. Ratio": {
                        "name": "Marker Custom Asp. Ratio",
                        "disabled": true,
                        "default": "---"
                    }
                }
            },
            "7": {
                "name": "7",
                "settings": {
                    "Safe Area Marker": {
                        "name": "Safe Area Marker",
                        "default": "Off",
                        "settings": ["Yellow", "Blue", "Green", "Red", "Black", "Gray", "White", "Off"]
                    },
                    "Basis for Marker Safe Area": {
                        "name": "Basis for Marker Safe Area",
                        "disabled": true,
                        "default": "---"
                    },
                    "Marker Safe Area %": {
                        "name": "Marker Safe Area",
                        "default": "95%",
                        "settings": ["80%", "90%", "92.5%", "95%"]
                    }
                }
            }
        }
    },
    "Network Settings": {
        "name": "Network Settings",
        "id": "networkSettings",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "Connection Settings": {
                        "name": "Connections Settings",
                        "default": "1:",
                        "type": "big_select",
                        "settings": ["1", "2", "3", "4"]
                    },
                    "Activate": {
                        "name": "Activate",
                        "default": "Off",
                        "type": "off",
                        "title": "Browser Remote",
                        "settings": ["Off"]
                    },
                    "Browser Remote Settings": {
                        "name": "Browser Remote Settings",
                        "default": false,
                        "type": "list",
                        "parentName": "Network Settings",
                        "settings": {
                            "Port No.": {
                                "name": "Port No.",
                                "default": "80",
                                "type": "select_cancel",
                                "title": "Port No.",
                                "parentName": "Browser Remote Settings",
                                "settings": ["0", "0", "0", "8", "0"]
                            },
                            "Camera ID": {
                                "name": "Camera ID",
                                "default": "C200",
                                "title": "C200",
                                "type": "keyboard"
                            },
                            "User Settings": {
                                "name": "User Settings",
                                "default": "One User (Full)",
                                "settings": ["One User (Full)", "Two Users (Camera/Meta)"]
                            },
                            "Full: User Name": {
                                "name": "Full: User Name",
                                "default": "Full",
                                "title": "Full",
                                "type": "keyboard"
                            },
                            "Full: Password": {
                                "name": "Full: Password",
                                "default": "12345678",
                                "title": "12345678",
                                "type": "keyboard"
                            },
                            "Camera: User Name": {
                                "name": "Camera: User Name",
                                "disabled": true,
                                "default": "---"
                            },
                            "Camera: Password": {
                                "name": "Camera: Password",
                                "disabled": true,
                                "default": "---"
                            },
                            "Meta: User Name": {
                                "name": "Meta: User Name",
                                "disabled": true,
                                "default": "---"
                            },
                            "Meta: Password": {
                                "name": "Meta: Password",
                                "disabled": true,
                                "default": "---"
                            }
                        }
                    }
                }
            }
        }
    },
    "Assignable Buttons": {
        "name": "Assignable Buttons",
        "id": "assingnableButtons",
        "settings": {
            "1": {
                "name": "1",
                "title": "Camera",
                "settings": {
                    "1": {
                        "name": "1",
                        "default": "Magn.: All",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "2": {
                        "name": "2",
                        "hasIcons": true,
                        "default": "Peaking: All",
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "3": {
                        "name": "3",
                        "hasIcons": true,
                        "default": "Zebra: All",
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "4": {
                        "name": "4",
                        "hasIcons": true,
                        "default": "WFM: All",
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "5": {
                        "name": "5",
                        "hasIcons": true,
                        "default": "ISO/Gain",
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "6": {
                        "name": "6",
                        "hasIcons": true,
                        "default": "Shutter",
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "7": {
                        "name": "7",
                        "hasIcons": true,
                        "default": "Display",
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    }
                }
            },
            "2": {
                "name": "2",
                "title": "Camera",
                "settings": {
                    "8": {
                        "name": "8",
                        "hasIcons": true,
                        "default": "FUNC",
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "9": {
                        "name": "9",
                        "default": "Audio Status",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "10": {
                        "name": "10",
                        "default": "Push Auto Iris",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "11": {
                        "name": "11",
                        "default": "One-Shot AF",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    }
                }
            },
            "3": {
                "name": "3",
                "title": "Camera Grip",
                "settings": {
                    "1": {
                        "name": "1",
                        "default": "Focus Guide",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    }
                }
            },
            "4": {
                "name": "4",
                "title": "LCD LM-V1",
                "settings": {
                    "1": {
                        "name": "1",
                        "default": "FUNC",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "2": {
                        "name": "2",
                        "default": "Display",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    }
                }
            },
            "5": {
                "name": "5",
                "title": "EVF-V70",
                "settings": {
                    "1": {
                        "name": "1",
                        "default": "FUNC",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "2": {
                        "name": "2",
                        "default": "EVF-V70 Setup",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "3": {
                        "name": "3",
                        "default": "Magn.: All",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "4": {
                        "name": "4",
                        "default": "(NONE)",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    }
                }
            },
            "6": {
                "name": "6",
                "title": "RC-V100",
                "settings": {
                    "1": {
                        "name": "1",
                        "default": "Magn.: All",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "2": {
                        "name": "2",
                        "default": "Peaking: All",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "3": {
                        "name": "3",
                        "default": "Zebra: All",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    },
                    "4": {
                        "name": "4",
                        "default": "WFM: All",
                        "hasIcons": true,
                        "settings": ["(NONE)", "One-Shot AF", "AF Lock", "Face AF", "Face Detection", "Tracking", "Focus Guide", "Peaking: All", "Peaking: VIDEO Output", "Peaking: VF Output", "Magn.: All", "Magn.: VF+VIDEO Output", "Magn.: SDI/HDMI Output", "Tele-converter", "Push Auto Iris", "Iris Mode", "Iris +", "Iris -", "ND +", "ND -", "AE Shift +", "AE Shift -", "Backlight", "Spotlight", "Zebra: All", "Zebra: VIDEO Output", "Zebra: VF Output", "WFM: All", "WFM: VF+VIDEO Output", "WFM: SDI Output", "LUT: All", "LUT: VIDEO Output", "LUT: VF Output", "LUT: SDI Output", "Set White Balance", "AWB Lock", "AWB", "Set A", "Set B", "Daylight", "Tungsten", "Kelvin", "LCD LM-V1 Setup", "Viewfinder Setup", "EVF-V70 Setup", "OSD Output", "Display", "Markers: All", "Markers: VF+VIDEO Output", "Markers: SDI/HDMI Output", "Color Bars", "Photo", "Review Recording", "Time Code", "Time Code Hold", "Add Shot Mark", "Add OK Mark", "Add Check Mark", "Headphones +", "Headphones -", "Monitor Channels", "Audio Level Indicator", "FUNC", "Slow Motion Recording", "Shutter", "ISO/Gain", "White Balance", "Status", "Audio Status", "Custom Picture/HDR", "My Menu", "Inintialize Media", "User Setting (NONE)"]
                    }
                }
            }
        }
    },
    "System Setup": {
        "name": "System Setup",
        "id": "systemSetup",
        "settings": {
            "1": {
                "name": "1",
                "settings": {
                    "Reset": {
                        "name": "Reset",
                        "default": false,
                        "type": "list",
                        "parentName": "System Setup",
                        "settings": {
                            "All Settings": {
                                "name": "All Settings",
                                "default": false,
                                "type": "question",
                                "parentName": "Reset",
                                "question": "Reset all settings to default values?",
                            },
                            "Camera Settings": {
                                "name": "Camera Settings",
                                "default": false,
                                "type": "question",
                                "parentName": "Reset",
                                "question": "Reset settings?",
                            },
                            "Assignable Buttons": {
                                "name": "Assignable Buttons",
                                "default": false,
                                "type": "question",
                                "parentName": "Reset",
                                "question": "Reset settings?",
                            }
                        }
                    },
                    "Transfer Menu/CP": {
                        "name": "Transfer Menu/CP",
                        "default": false,
                        "type": "list",
                        "parentName": "System Setup",
                        "settings": {
                            "Save": {
                                "name": "Save",
                                "default": false,
                                "type": "list",
                                "parentName": "System Setup > Transfer Menu/CP",
                                "settings": {
                                    "To Camera": {
                                        "name": "To Camera",
                                        "default": false,
                                        "type": "question",
                                        "subTitle": "To Camera",
                                        "parentName": "Transfer Menu/CP > Save",
                                        "question": "Overwrite and save data?" // add someth to show subsub set name
                                    },
                                    "To SD Card B": {
                                        "name": "To SD Card B",
                                        "default": false,
                                        "type": "question",
                                        "subTitle": "To SD Card B",
                                        "parentName": "Transfer Menu/CP > Save",
                                        "question": "Overwrite and save data?" // add someth to show subsub set name
                                    }
                                }
                            },
                            "Load": {
                                "name": "Load",
                                "default": false,
                                "type": "list",
                                "parentName": "System Setup > Transfer Menu/CP",
                                "settings": {
                                    "From Camera": {
                                        "name": "From Camera",
                                        "default": false,
                                        "disabled": true
                                    },
                                    "From SD Card B": {
                                        "name": "From SD Card B",
                                        "default": false,
                                        "disabled": true
                                    }
                                }
                            }
                        }
                    },
                    "Time Zone": {
                        "name": "Time Zone",
                        "default": "UTC-08:00", // ???
                        "type": "time_zone"

                    },
                    "Date/Time": {
                        "name": "Date/Time",
                        "default": "Apr.30,2019 3:41 PM",
                        "type": "date_time" // ?
                    },
                    "Date Format": {
                        "name": "Date Format",
                        "default": "MDY",
                        "settings": ["YMD", "YMD/24H", "MDY", "MDY/24H", "DMY", "DMY/24H"]
                    },
                    "Language": {
                        "name": "Language",
                        "default": "English",
                        //"type": "loop", // ???
                        "settings": ["Deutsch", "English", "Español", "Français", "Italiano", "Polski", "Português", "Русский", "简体中文", "한국어", "日本語"]
                    },
                    "REMOTE Term.": {
                        "name": "REMOTE Term.",
                        "default": "Standard",
                        "settings": ["RC-V100 (REMOTE A)", "Standard"]
                    }
                }
            },
            "2": {
                "name": "2",
                "settings": {
                    "HDMI Max Res.": {
                        "name": "HDMI Max Res.",
                        "default": "1920x1080",
                        "settings": ["3840x2160", "1920x1080"]
                    },
                    "SDI Output": {
                        "name": "SDI Output",
                        "default": "1920x1080",
                        "settings": ["2048x1080 / 1920x1080", "1920x1080"]
                    },
                    "3G-SDI Mapping": {
                        "name": "3G-SDI Mapping",
                        "default": "Level B",
                        "settings": ["Level A", "Level B"]
                    },
                    "SDI/HDMI Scan Mode": {
                        "name": "SDI/HDMI Scan Mode",
                        "default": "P",
                        "settings": ["P", "PsF"]
                    
                    },
                }
            },
            "3": {
                "name": "3",
                "settings": {
                    "Time Code Mode": {
                        "name": "Time Code Mode",
                        "default": "Preset",
                        "settings": ["Preset", "Regen."]
                    },
                    "Time Code Run": {
                        "name": "Time Code Run",
                        "default": "Rec Run",
                        "settings": ["Rec Run", "Free Run"]
                    },
                    "Time Code DF/NDF": {
                        "name": "Time Code DF/NDF",
                        "default": "DF",
                        "settings": ["DF", "NDF"]
                    },
                    "Set Time Code": {
                        "name": "Set Time Code",
                        "default": false,
                        "type": "change_reset",
                        "settings": ["00 : 00 : 00 . 00"]            
                    },
                    "User Bit Type": {
                        "name": "User Bit Type",
                        "default": "Setting",
                        "settings": ["Setting", "Time", "Date"]                   
                    },
                }
            },
            "4": {
                "name": "4",
                "settings": {
                    "Camera Ctrl Dail": {
                        "name": "Camera Ctrl Dail",
                        "default": "Iris",
                        "settings": ["Iris", "ISO/Gain", "Off"]
                    },
                    "Camera Grip Ctrl Dail": {
                        "name": "Camera Grip Ctrl Dail",
                        "default": "Iris",
                        "settings": ["Iris", "ISO/Gain", "Off"]
                    },
                    "Camera Ctrl Dail Dir.": {
                        "name": "Camera Ctrl Dail Dir.",
                        "default": "Normal",
                        "settings": ["Reverse", "Normal"]
                    },
                    "Camera Grip Ctrl Dail Dir.": {
                        "name": "Camera Grip Ctrl Dail Dir.",
                        "default": "Normal",
                        "settings": ["Reverse", "Normal"]
                    }, 
                    "EVF-V70 SELECT Dail Dir.": {
                        "name": "SEVF-V70 SELECT Dail Dir.",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]                
                    },
                    "Key Lock": {
                        "name": "Key Lock",
                        "default": "All Except REC Button",
                        "settings": ["All Buttons", "All Except REC Button"]                   
                    },
                    "Camera REC Button": {
                        "name": "Camera REC Button",
                        "default": "Enable",
                        "settings": ["Disable", "Enable"]                   
                    },
                    "Camera Grip REC Button": {
                        "name": "Camera Grip REC Button",
                        "default": "Enable",
                        "settings": ["Disable", "Enable"]                   
                    },
                }
            },
            "5": {
                "name": "5",
                "settings": {
                    "LED": {
                        "name": "LED",
                        "default": false,
                        "type": "list",
                        "parentName": "System Setup",
                        "settings": {
                            "Tally Lamp (Front)": {
                                "name": "Tally Lamp (Front)",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "Tally Lamp (Rear)": {
                                "name": "Tally Lamp (Rear)",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "CFast Access LED": {
                                "name": "CFast Access LED",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "SD Card Access LED": {
                                "name": "SD Card Access LED",
                                "default": "On",
                                "settings": ["On", "Off"]
                            },
                            "(Ethernet)": {
                                "name": "Ethernet",
                                "default": "On",
                                "settings": ["On", "Off"]
                            }
                        }
                    },
                    "Fan": {
                        "name": "Fan",
                        "default": false,
                        "type": "list",
                        "parentName": "System Setup",
                        "settings": {
                            "Mode": {
                                "name": "Mode",
                                "default": "Always On",
                                "settings": ["Automatic", "Always On"]
                            },
                            "Fan Speed (Always)": {
                                "name": "Fan Speed (Always)",
                                "default": "Low",
                                "settings": ["High", "Low"]
                            }
                        }
                    },
                    "Touch Screen Response": {
                        "name": "Touch Screen Response",
                        "default": "Normal",
                        "settings": ["Normal", "Low"]
                    },
                    "Review Recording": {
                        "name": "Review Recording",
                        "default": "Entire Clip",
                        "settings": ["Entire Clip", "Last 4 sec"]
                    }, 
                    "GPS Auto Time": {
                        "name": "GPS Auto Time",
                        "disabled": true,
                        "default": "---",
                        "settings": ["---"]                
                    },
                }
            },
            "6": {
                "name": "6",
                "settings": {
                    "Retract Lens": {
                        "name": "Retract Lens",
                        "default": "On",
                        "settings": ["On", "Off"]
                    },                    
                    "Rest Hour Meter": {
                        "name": "Rest Hour Meter",
                        "default": false,
                        "type": "question",                               
                        "title": false,
                        "question": "Since Reset: 309h"
                    },
                    "Firmware": {
                        "name": "Firmware",
                        "default": false,
                        "type": "list",
                        "parentName": "System Setup",
                        "settings": {
                            "Camera": {
                                "name": "Camera",
                                "disabled": true,
                                "default": "1.0.5.1.00",
                               
                            },
                            "Lens": {
                                "name": "Lens",
                                "disabled": true,
                                "default": "1.2.0",
                                
                            }
                        }
                    },
                }
            }
        }
    },
    "My menu": {
        "name": "My Menu",
        "id": "myMenu",
        "settings": {
            "1": {
                "name": "1",
                "title": "CAMERA-1",
                "settings": {
                    "Edit": {
                        "name": "Edit",
                        "default": false,
                        "type": "list",
                        "parentName": "My menu",
                        "title": "CAMERA-1",
                        "settings": {
                            "Register": {
                                "name": "Register",
                                "default": false,
                                "type": "register",
                                "settings": {
                                    "title": "Select a menu item to add to My Menu"
                                }
                            },
                            "Move": {
                                "name": "Move",
                                "default": false,
                                "disabled": true
                            },
                            "Delete": {
                                "name": "Delete",
                                "default": false,
                                "disabled": true
                            },
                            "Reset All": {
                                "name": "Reset All",
                                "default": false,
                                "type": "question",                                  
                                "title": false,
                                "question": "Reset settings?"                
                            },
                            "Rename": {
                                "name": "Rename",
                                "default": "CAMERA-1",
                                "title": "CAMERA-1",
                                "type": "keyboard"
                            }
                        }
                    }
                }
            },
            "2": {
                    "name": "2",
                    "title": "CAMERA-2",
                    "settings": {
                        "Edit": {
                            "name": "Edit",
                            "default": false,
                            "type": "list",
                            "parentName": "My menu",
                            "title": "CAMERA-2",
                            "settings": {
                                "Register": {
                                    "name": "Register",
                                    "default": false,
                                    "type": "register",
                                    "settings": {
                                        "title": "Select a menu item to add to My Menu"
                                    }
                                },
                                "Move": {
                                    "name": "Move",
                                    "default": false,
                                    "disabled": true
                                },
                                "Delete": {
                                    "name": "Delete",
                                    "default": false,
                                    "disabled": true
                                },
                                "Reset All": {
                                    "name": "Reset All",
                                    "default": false,
                                    "type": "question",                               
                                    "title": false,
                                    "question": "Reset settings?"                
                                },
                                "Rename": {
                                    "name": "Rename",
                                    "default": "CAMERA-2",
                                    "title": "CAMERA-2",
                                    "type": "keyboard"
                                }
                            }
                        }
                    }
                },
                "3": {
                    "name": "3",
                    "title": "CAMERA-3",
                    "settings": {
                        "Edit": {
                            "name": "Edit",
                            "default": false,
                            "type": "list",
                            "parentName": "My menu",
                            "title": "CAMERA-3",
                            "settings": {
                                "Register": {
                                    "name": "Register",
                                    "default": false,
                                    "type": "register",
                                    "settings": {
                                        "title": "Select a menu item to add to My Menu"
                                    }
                                },
                                "Move": {
                                    "name": "Move",
                                    "default": false,
                                    "disabled": true
                                },
                                "Delete": {
                                    "name": "Delete",
                                    "default": false,
                                    "disabled": true
                                },
                                "Reset All": {
                                    "name": "Reset All",
                                    "default": false,
                                    "type": "question",                                  
                                    "title": false,
                                    "question": "Reset settings?"                
                                },
                                "Rename": {
                                    "name": "Rename",
                                    "default": "CAMERA-3",
                                    "title": "CAMERA-3",
                                    "type": "keyboard"
                                }
                            }
                        }
                    }
                },
                "4": {
                    "name": "4",
                    "title": "CAMERA-4",
                    "settings": {
                        "Edit": {
                            "name": "Edit",
                            "default": false,
                            "type": "list",
                            "parentName": "My menu",
                            "title": "CAMERA-4",
                            "settings": {
                                "Register": {
                                    "name": "Register",
                                    "default": false,
                                    "type": "register",
                                    "settings": {
                                        "title": "Select a menu item to add to My Menu"
                                    }
                                },
                                "Move": {
                                    "name": "Move",
                                    "default": false,
                                    "disabled": true
                                },
                                "Delete": {
                                    "name": "Delete",
                                    "default": false,
                                    "disabled": true
                                },
                                "Reset All": {
                                    "name": "Reset All",
                                    "default": false,
                                    "type": "question",                                
                                    "title": false,
                                    "question": "Reset settings?"                
                                },
                                "Rename": {
                                    "name": "Rename",
                                    "default": "CAMERA-4",
                                    "title": "CAMERA-4",
                                    "type": "keyboard"
                                }
                            }
                        }
                    }
                },
                "5": {
                    "name": "5",
                    "title": "CAMERA-5",
                    "settings": {
                        "Edit": {
                            "name": "Edit",
                            "default": false,
                            "type": "list",
                            "parentName": "My menu",
                            "title": "CAMERA-5",
                            "settings": {
                                "Register": {
                                    "name": "Register",
                                    "default": false,
                                    "type": "register",
                                    "settings": {
                                        "title": "Select a menu item to add to My Menu"
                                    }
                                },
                                "Move": {
                                    "name": "Move",
                                    "default": false,
                                    "disabled": true
                                },
                                "Delete": {
                                    "name": "Delete",
                                    "default": false,
                                    "disabled": true
                                },
                                "Reset All": {
                                    "name": "Reset All",
                                    "default": false,
                                    "type": "question",                              
                                    "title": false,
                                    "question": "Reset settings?"                
                                },
                                "Rename": {
                                    "name": "Rename",
                                    "default": "CAMERA-5",
                                    "title": "CAMERA-5",
                                    "type": "keyboard"
                                }
                            }
                        }
                    }
                }
            }    
        

    },
    "Close": {
        "name": "Close",
        "id": "close"
    }





};

export default data;
